import JustValidate from './../../node_modules/just-validate';

const needFormValidation = new JustValidate('#get-in-touch-cta');

needFormValidation
	.addField('#lfirstname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			validator: (value) => {
				const fullNameRegex = /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/;
				return fullNameRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Full Name',
		},
	])
	.addField('#lcompany', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	])
	.addField('#lemail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global = document.querySelector('.loading-div');

document
	.querySelector('#get-in-touch-cta')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (needFormValidation.isValid == false) {
			return false;
		}

		loading_global.classList.add('active');

		const form = document.getElementById('get-in-touch-cta');
		const formData = new FormData(form);

		let fullName = formData.get('lfirstname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.append('lsource', 'Website Form - Zero Cost Consultation');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			company: formData.get('lcompany'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href = 'https://cyntexa.com/success';
	});
